<template>

<div class="image-form">

    <div class="loading animated fadeIn" v-if="uploading">
        <i class="icon_loading animate-spin"></i>
    </div>
    <div class="hover" v-else>
        <i class="pe-7s-user"></i>
        <p>cambiar foto de perfil</p> 
        <input type="file" name="myFile" @change="upload" ref="file">
    </div>

    <div 
        class="avatar" 
        :style="'background-image:url('+backgroundImage+')'" 
        >
    </div>
    <!-- <div 
        v-if="uploadedImage && uploadedImage.urlThumb"  
        class="avatar" 
        :style="'background-image:url(https://127.0.0.1:8000'+uploadedImage.urlThumb+')'" 
        >
    </div> -->
    

    <!-- <li v-if="image" class="animated fadeIn" :style="'background-image:url('+image.urlThumb+')'">
		<div class="close-button" @click="remove(image)" ><i class="material-icons">clear</i></div>
		<div class="thumb" ></div>
	</li> -->

</div>
</template>

<script>
import gql from 'graphql-tag'
export default {
	name: "uploadFiles",
	props:{
		image:{
            type: Object,
        },
    },
    watch: { 
        image: function(newVal) {
            if(newVal){
                this.backgroundImage = this.API_URL+newVal.url;
            }else{
                this.backgroundImage = require('@/assets/img/no-avatar-image.gif');
            }
        }
    },
    data() {
        return {
            uploadedImage:{},
            uploading:false,
            backgroundImage:'',
            API_URL: process.env.VUE_APP_API_URL,
        }
    },
    mounted(){
        // if(this.image){
        //     this.backgroundImage = this.image;
        // }else{
        //     this.backgroundImage = require('@/assets/img/no-avatar-image.gif');
        // }
    },
	methods:{
		upload(event){
            this.uploading=true;
			var input = event.target;
			if (input.files && input.files[0]) {
				if( input.files[0].type == "image/jpeg" || input.files[0].type == "image/png" ){
					return this.$apollo.mutate({
						mutation: gql`mutation ($file:Upload! ){
							upload(file : $file){
								id
								filename
								url
								urlThumb
								type
								size
							}
						}`,
						variables: {
							file: input.files[0]
						}
					})
					.then( data => {
                        this.$emit('uploaded',data.data.upload);
                        this.uploadedImage = data.data.upload;
                        this.backgroundImage = 'https://127.0.0.1:8000'+data.data.upload.urlThumb;
                        this.uploading=false;
                        return data.data.upload;
					})
					.catch(err => {
                        console.log(err)
                        this.uploading=false;
						return false;
					});
				}	
			}
		},
		remove(image){
			this.images.forEach( (existentImage, index) => {
				if( image.id == existentImage.id){
					this.$emit('deleted',index);
				}
			});
		},
	}
};
</script>

<style scoped>
.image-form{
    width:100%;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}

.image-form .button{
    position: absolute;
    background:none;
    border:none;
    width: 100%;
    height: 100%;
}
.image-form .button input{
    opacity: 0;
}

.image-form .hover{
    position: absolute;
    border:none;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.4); 
    display: flex;
    align-items: center;
    justify-content:center;
    flex-flow: column;
    color: #fff;
    opacity: 0;
    cursor: pointer;
}
.image-form:hover .hover{
    opacity: 1;
}
.image-form .hover i{
    font-size: 34px;
}
.image-form .hover p{
    font-size: 10px;
    margin:8px 0px;
    text-transform: uppercase;
}
.image-form .hover input{
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0px;
    opacity:0;
    cursor: pointer;
}

.image-form .loading{
    position: absolute;
    border:none;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.4); 
    display: flex;
    align-items: center;
    justify-content:center;
    flex-flow: column;
    color: #fff;
    opacity: 1;
    cursor: pointer;
}

.image-form .loading i{
    font-size: 34px;
}



.avatar{
    width: 100%;
    background-color: #ccc;
    display: block;
    background-size: cover;
    background-position: center center;
}
.avatar:after {
  content: "";
  display: block;
  /* padding-bottom: 100%; */
}


</style>
